import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import EmployeeContractDetails from '../../../components/hr/contracts/general/details';
import { useParams } from 'react-router-dom';

interface EmployeeContractDetailsPageProps {
}

const EmployeeContractDetailsPage: React.FC<EmployeeContractDetailsPageProps> = (props: EmployeeContractDetailsPageProps) => {
    const {topbar} = useStore();
    const params: any = useParams();

    useEffect(() => {
        topbar.show("Contract", [
            {key: "home", icon: faHome, href: "/"},
            {key: "contracts", text: 'Contracts'}
        ]);
    }, []);

    return <Stack>
        <EmployeeContractDetails contractId={params.contractId} />
    </Stack>;
};

export default EmployeeContractDetailsPage;
